import { createContext } from 'react';
export const ChartContext = createContext();